/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createAcot } from '../../factoriesAny.js';
export var acotDependencies = {
  BigNumberDependencies,
  typedDependencies,
  createAcot
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/entry/dependenciesAny/dependenciesAcot.generated.js
// module id = null
// module chunks = 